import { ApplicationPermission } from '../models/application-permission.model';

export abstract class IPermissionService {

  abstract hasPermission(permission: string[]): boolean;

  abstract setPermissions(permissions: string[]): void;
}
